/* ---- XSS Sanitizer ---- */
function sanitizeHTML(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');

  /* Remove dangerous tags */
  doc.querySelectorAll('script, iframe, object, embed, form').forEach(function(el) {
    el.remove();
  });

  /* Remove dangerous attributes */
  doc.querySelectorAll('*').forEach(function(el) {
    var attrs = Array.from(el.attributes);
    attrs.forEach(function(attr) {
      var name = attr.name.toLowerCase();
      var value = attr.value.toLowerCase().trim();
      if (
        name.startsWith('on') ||
        (name === 'href' && value.startsWith('javascript:')) ||
        (name === 'src' && value.startsWith('javascript:')) ||
        name === 'srcdoc'
      ) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
}

class WishlistProduct extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onAddWishlist);
    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
    this.BUTTON_ACTIVE_CLASS = 'active';
    this.onAddActiveClass();
    this.WishlistItemCounter();
  }

  WishlistItemCounter() {
    var WISHLIST_ITEM_COUNT = document.querySelectorAll('.wishlist__count');
    var wishlist_item_length = this.getWishlist().length;
    if (WISHLIST_ITEM_COUNT) {
      WISHLIST_ITEM_COUNT.forEach(function(singleItem) {
        singleItem.innerText = wishlist_item_length;
      });
    }
  }

  onAddActiveClass() {
    var wishlistAddedButton = this.querySelector('button');
    if (wishlistAddedButton != null) {
      var productHandle = wishlistAddedButton.dataset.productHandle || false;
      if (!productHandle)
        return console.error(
          '[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
        );
      if (this.wishlistContains(productHandle))
        wishlistAddedButton.classList.add(this.BUTTON_ACTIVE_CLASS);
    }
  }

  onAddWishlist() {
    var wishlistItem = this.querySelector('button');
    var productHandle = wishlistItem.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        '[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
      );

    this.updateWishlist(productHandle);
    this.WishlistItemCounter();

    var grid = document.querySelector('[grid-wishlist]') || false;

    if (grid) {
      /* On wishlist page - remove the product with animation */
      var productCard = this.closest('.product__mt__card');
      var columnWrapper = (productCard && productCard.closest('.col.mb-30')) || productCard;

      if (columnWrapper) {
        columnWrapper.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
        columnWrapper.style.opacity = '0';
        columnWrapper.style.transform = 'scale(0.9)';

        setTimeout(function() {
          columnWrapper.remove();

          var remainingItems = document.querySelectorAll(
            '[grid-wishlist] .col.mb-30, [grid-wishlist] .product__mt__card'
          );
          if (remainingItems.length === 0) {
            var wishlistPageContainer = document.querySelector('.wishlist-page-mt');
            if (wishlistPageContainer) {
              wishlistPageContainer.classList.remove('wishlist_exists');
            }
          }
        }, 300);
      }
    } else {
      /* On regular pages - toggle heart icon */
      wishlistItem.classList.add('loading', 'adding');
      setTimeout(function() {
        wishlistItem.classList.remove('loading');
        wishlistItem.classList.toggle('active');
      }, 500);
      setTimeout(function() {
        var addingBtn = document.querySelector('.adding');
        if (addingBtn) {
          addingBtn.classList.remove('adding');
        }
      }, 1000);
    }
  }

  getWishlist() {
    var wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(this.LOCAL_STORAGE_DELIMITER);
    return [];
  }

  setWishlist(array) {
    var wishlist = array.join(this.LOCAL_STORAGE_DELIMITER);
    if (array.length)
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist;
  }

  updateWishlist(handle) {
    var wishlist = this.getWishlist();
    var indexInWishlist = wishlist.indexOf(handle);
    if (indexInWishlist === -1) wishlist.push(handle);
    else wishlist.splice(indexInWishlist, 1);
    return this.setWishlist(wishlist);
  }

  wishlistContains(handle) {
    var wishlist = this.getWishlist();
    return wishlist.indexOf(handle) !== -1;
  }
}

customElements.define('wishlist-item', WishlistProduct);

var newWishlistObj = new WishlistProduct();

document.addEventListener('DOMContentLoaded', function() {
  var grid = document.querySelector('[grid-wishlist]') || false;
  if (grid) {
    setupGrid(grid);
  }
});

/* ---- Build remove button using safe DOM APIs (no innerHTML) ---- */
function buildRemoveButton(productHandle) {
  var wishlistEl = document.createElement('wishlist-item');
  wishlistEl.className = 'wishlist-remove-btn';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'wishlist-btn active';
  btn.setAttribute('data-product-handle', productHandle);
  btn.setAttribute('aria-label', 'Remove from wishlist');
  btn.setAttribute('title', 'Remove from wishlist');

  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '20');
  svg.setAttribute('height', '20');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

  var line1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line1.setAttribute('x1', '18');
  line1.setAttribute('y1', '6');
  line1.setAttribute('x2', '6');
  line1.setAttribute('y2', '18');
  line1.setAttribute('stroke', 'currentColor');
  line1.setAttribute('stroke-width', '2');
  line1.setAttribute('stroke-linecap', 'round');

  var line2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
  line2.setAttribute('x1', '6');
  line2.setAttribute('y1', '6');
  line2.setAttribute('x2', '18');
  line2.setAttribute('y2', '18');
  line2.setAttribute('stroke', 'currentColor');
  line2.setAttribute('stroke-width', '2');
  line2.setAttribute('stroke-linecap', 'round');

  svg.appendChild(line1);
  svg.appendChild(line2);
  btn.appendChild(svg);
  wishlistEl.appendChild(btn);

  return wishlistEl;
}

/* ---- Setup Wishlist Grid ---- */
var setupGrid = function(grid) {
  var wishlist = newWishlistObj.getWishlist();
  var wishlistExistBtn = document.querySelector('.wishlist-page-mt');

  if (wishlist.length > 0) {
    if (wishlistExistBtn) wishlistExistBtn.classList.add('wishlist_exists');
  } else {
    if (wishlistExistBtn) wishlistExistBtn.classList.remove('wishlist_exists');
  }

  var requests = wishlist.map(function(handle) {
    var productTileTemplateUrl = '/products/' + encodeURIComponent(handle) + '?view=card';
    return fetch(productTileTemplateUrl)
      .then(function(res) {
        if (res.status === 200) {
          return res.text();
        }
        return '';
      })
      .catch(function(error) {
        console.error('Error fetching product:', error);
        return '';
      });
  });

  Promise.all(requests).then(function(responses) {
    /* Clear grid first */
    grid.innerHTML = '';

    responses
      .filter(function(r) { return r !== ''; })
      .forEach(function(productHtml) {
        /* Sanitize fetched HTML before parsing */
        var sanitized = sanitizeHTML(productHtml);

        /* Parse sanitized HTML */
        var temp = document.createElement('div');
        temp.innerHTML = sanitized;

        /* Find product card */
        var productCard = temp.querySelector('.product__mt__card') || temp.firstElementChild;
        if (!productCard) return;

        /* Get product handle */
        var productHandle = '';
        var wishlistBtn = productCard.querySelector('[data-product-handle]');
        if (wishlistBtn) {
          productHandle = wishlistBtn.getAttribute('data-product-handle');
        }

        /* Add remove button if handle found and button not already present */
        if (productHandle && !productCard.querySelector('.wishlist-remove-btn')) {
          var removeBtn = buildRemoveButton(productHandle);
          productCard.insertBefore(removeBtn, productCard.firstChild);
        }

        /* Wrap in column div if needed */
        var wrapper;
        if (temp.querySelector('.col')) {
          wrapper = temp.firstElementChild;
        } else {
          wrapper = document.createElement('div');
          wrapper.className = 'col mb-30';
          wrapper.appendChild(productCard);
        }

        /* Append safely to grid */
        grid.appendChild(wrapper);
      });
  });
};